require('./bootstrap-vue')
require('./vue-paginate')
require('./vue-axios')
require('./vuelidate')
require('./vuetify')
require('./vue-blockUI')
require('./vuex')
